// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"_2-HtFwz4pptRIqoT12Bokj","dropdown-home":"VxVFb_3yUWdpmttU77sPG _2-HtFwz4pptRIqoT12Bokj","text-left":"_3tECoTnfuqL__OtOcoUG6H","text-left-home":"zt-iux5LGVqG06Ykf2EVW _3tECoTnfuqL__OtOcoUG6H","text-middle":"_284mheti6NLTZyQENEWKLw","icon":"wLZHUZlwC9t8kh4gSQnbg","icon-home":"_1jIdcYtZBc4PVclc45M5DM wLZHUZlwC9t8kh4gSQnbg","dropdown-arrow":"_1zPGVYVMoK-3vwGW-9ouHA","dropdown-arrow-home":"qAYw4lc_Pkck4wKQICywm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/General/FormElements/SelectPeople.scss
// module id = 123
// module chunks = 0 4 5 6 10 29